export enum ResourceID {
  // Models
  CannonModel,
  CannonBallModel,
  RocketModel,
  MineModel,
  TableTopModel,
  RoundedTableTopModel,
  TableLegModel,
  ConveyorModel,
  GearModel,
  LedModel,
  BoxModel,
  DoorModel,
  FlagModel,
  ConPModel,
  Block1x1Model,
  Block1x2Model,
  Block1x3Model,
  Block1x4Model,
  Block1x5Model,
  Block2x2Model,
  BlockDestroyModel,
  Jam1x1Model,
  Jam1x2Model,
  Jam1x3Model,
  CannedBlockCube1x1Model,
  CannedBlockCube1x2Model,
  CannedBlockCube1x3Model,
  CylinderColored1x1Model,
  CylinderColored1x2Model,
  CylinderColored1x3Model,
  CylinderGrey1x1Model,
  CylinderGrey1x2Model,
  CylinderGrey1x3Model,
  IceModel,
  PlasticBlock1x1Model,
  PlasticBlock1x2Model,
  PlasticBlock1x3Model,
  PlasticBlock1x4Model,
  PlasticBlock1x5Model,
  PlasticBlock2x2Model,
  ConeCrownModel,
  ConeModel,
  TreeBlock1x1Model,
  TreeBlock1x2Model,
  TreeBlock1x3Model,
  TreeBlock1x4Model,
  TreeBlock1x5Model,
  WatermelonModel,
  Particle1Model,
  Particle2Model,

  // Barriers — obstacles bolted to the tabletop, not breakable blocks. One
  // shared material (barrier_M), so the parts combine into a single barrier.
  BarrierBearingModel,
  BarrierBladeModel,
  BarrierHammerModel,
  BarrierPillarModel,
  
  // Textures
  BackgroundTexture,
  EscalatorBackgroundTexture,
  EscalatorTopTexture,
  EscalatorWallTexture,
  EscalatorLedBaseTexture,
  EscalatorLedEmissiveTexture,
  CloudTexture,
  AirBalloonTexture,
  BackgroundCastleTexture,
  BoxTexture2,
  BoxTexture3,
  BoxNormal2,
  BoxNormal3,
  PurpleBoxTexture,
  GreenBoxTexture,
  AuthoredBoxNormal,
  PurpleBox2x2Texture,
  GreenBox2x2Texture,
  Block2x2Normal,
  JarCherryTexture,
  JarPlumTexture,
  JarLemonTexture,
  JarFigTexture,
  SquareCanRedTexture,
  SquareCanOrangeTexture,
  SquareCanYellowTexture,
  SquareCanGreenTexture,
  SquareCanLightBlueTexture,
  SquareCanBlueTexture,
  SquareCanPinkTexture,
  MetalNormalMap,
  CylinderRedTexture,
  CylinderOrangeTexture,
  CylinderYellowTexture,
  CylinderGreenTexture,
  CylinderLightBlueTexture,
  CylinderBlueTexture,
  CylinderPinkTexture,
  IronCanAltTexture,
  IronCanNormal,
  ConeGoldenTexture,
  ConeRedTexture,
  ConeTwoNormalTexture,
  ConeV3GoldenTexture,
  ConeV3RedTexture,
  ConeV3OrangeTexture,
  ConeV3YellowTexture,
  ConeV3GreenTexture,
  ConeV3LightBlueTexture,
  ConeV3BlueTexture,
  ConeV3PinkTexture,
  ConeV3NormalTexture,
  IceSmallTexture,
  IceBigTexture,
  IceGiantTexture,
  IceCrackedTexture,
  IceNormalTexture,
  IceCrackedNormalTexture,
  PlasticPinkTexture,
  PlasticPink2x2Texture,
  PlasticRedTexture,
  PlasticRed2x2Texture,
  PlasticYellowTexture,
  PlasticYellow2x2Texture,
  PlasticGreenTexture,
  PlasticGreen2x2Texture,
  PlasticBlueTexture,
  PlasticBlue2x2Texture,
  PlasticOrangeTexture,
  PlasticOrange2x2Texture,
  PlasticPurpleTexture,
  PlasticPurple2x2Texture,
  PlasticNewNormal,
  Plastic2x2Normal,
  PlasticLightBlueTexture,
  PlasticLightBlue2x2Texture,
  TableBlueBaseMap,
  TableGreyVioletBaseMap,
  TableRedBaseMap,
  TableRoundBlueBaseMap,
  TableRoundGreyVioletBaseMap,
  TableRoundRedBaseMap,
  TableNormalMap,
  CannonBaseMap,
  CannonNormalMap,
  BigBallBaseMap,
  BigBallNormalMap,
  CannonModelBaseMap,
  CannonModelNormalMap,
  RocketTexture,
  MineBaseMap,
  MineNormalMap,
  MineEmissiveMap,
  MineOrmMap,
  TreeTexture,
  TreeNormalMap,
  WatermelonTexture,
  WatermelonNormalMap,
  BarrierTexture,
  BarrierNormal,
  
  // VFX ================================================================================================================
  Smog,
  Fire,

  // Jam
  JamCherryTexture,
  JamFigTexture,
  JamLemonTexture,
  JamPlumTexture,

  // Fluid Particles
  FluidParticle1,
  FluidParticle2,
  FluidParticle3,

  // Watermelon
  WatermelonJuiceTexture,
    
  // Smoke
  SmokePuff1,
  SmokePuff2,
  SmokePuff3,
  SmokePuff4,

  // Glows
  ParticleGlow1,
  CircleGlow1,
  CircleGlow2,
  EllipseGlow1,
  SparkGlow4,
  WaveGlow1,
  WaveGlow2,
  ShockwaveGlow1,
  ShockwaveGlow2,
  ShockwaveGlow3,
  ShockwaveGlow4,
  ShockwaveGlow5,
  ShockwaveGlow6,

  // Splinters & Shards
  SplinterStone1,
  SplinterStone2,
  SplinterStone3,

  SplinterIce1,
  SplinterIce2,
  SplinterIce3,

  SplinterWood1,
  SplinterWood2,
  SplinterWood3,

  SplinterBrick1,
  SplinterBrick2,
  SplinterBrick3,

  SplinterColumn1,
  SplinterColumn2,
  SplinterColumn3,

  SplinterGreenBox1,
  SplinterGreenBox2,
  SplinterGreenBox3,

  SplinterPurpleBox1,
  SplinterPurpleBox2,
  SplinterPurpleBox3,

  SplinterPlasticBlue1,
  SplinterPlasticBlue2,
  SplinterPlasticBlue3,

  SplinterPlasticGreen1,
  SplinterPlasticGreen2,
  SplinterPlasticGreen3,

  SplinterPlasticLightBlue1,
  SplinterPlasticLightBlue2,
  SplinterPlasticLightBlue3,

  SplinterPlasticOrange1,
  SplinterPlasticOrange2,
  SplinterPlasticOrange3,

  SplinterPlasticPink1,
  SplinterPlasticPink2,
  SplinterPlasticPink3,

  SplinterPlasticPurple1,
  SplinterPlasticPurple2,
  SplinterPlasticPurple3,

  SplinterPlasticRed1,
  SplinterPlasticRed2,
  SplinterPlasticRed3,

  SplinterPlasticYellow1,
  SplinterPlasticYellow2,
  SplinterPlasticYellow3,

  GlassShard1,
  GlassShard2,
  GlassShard3,
  GlassShard4,

  // Noises Textures
  PerlinNoiseTexture,
  CloudNoiseTexture,
  VornoiNoiseTexture,
}
